export const COLORS = {
  primary: "#13A89E",
};
